import React, { useContext } from "react";
import ZenDesk from "react-zendesk";
import { PageContext } from "./PageContext";

export const ZenDeskWidget=()=>{
    const pageContext = useContext(PageContext);
    if (pageContext){
        const appID = pageContext.glSettings.ChatPluginSrc;
        if (appID!==""){
            return(
                <ZenDesk defer zendeskKey={appID}></ZenDesk>
            )
        }else{
            return (null);
        }
    }else{
        return (null);
    }
}